module.exports = __webpack_public_path__ + "img/scenario_travel_icon.bb1b99d1.png";